import moment from 'moment';
import { Filters, List, ListPageLayout } from 'framework/list';
import KpiValuesTable from './KpiValuesTable';
import KpiValueLayout from './KpiValueLayout';
import useKPIService from '../useKPIService';
import { DATE_FORMAT } from 'framework/utils';
import { useServiceCatalogId } from '../../useServiceCatalogId';
import ViewServiceCatalogPageMenu from '../../Show/ViewServiceCatalogPageMenu';
import { ShowPageLayout } from 'framework/ui/layout';
import ListKpiValuesBreadcrumbs from './ListKpiValuesBreadcrumbs';
import ServiceCatalogHeader from '../../shared/ServiceCatalogHeader';
import KpiValuesStaticFilters from './filter/KpiValuesStaticFilters';
import { Typography } from '@mui/material';

const KpiValuesListPage = () => {
  const { searchKPIValues } = useKPIService();
  const currentMonth = moment().format(DATE_FORMAT.INPUT_MONTH_VALUE);
  const startDate = moment().subtract(3, 'months').format(DATE_FORMAT.INPUT_MONTH_VALUE);

  const id = useServiceCatalogId();

  const filters = (
    <Filters>
      <KpiValuesStaticFilters />
    </Filters>
  );

  return (
    <ShowPageLayout
      breadcrumbs={<ListKpiValuesBreadcrumbs />}
      entityHeader={<ServiceCatalogHeader />}
      menu={<ViewServiceCatalogPageMenu />}
      hasSeparateSections
    >
      <List
        getDataMethod={async req => searchKPIValues(id, req)}
        defaultFilter={{ period: { ge: startDate, le: currentMonth } }}
      >
        <ListPageLayout
          header={
            <Typography variant="h4" color="primary" p={2} pb={0}>
              KPI values
            </Typography>
          }
        >
          <KpiValueLayout filter={filters}>
            <KpiValuesTable />
          </KpiValueLayout>
        </ListPageLayout>
      </List>
    </ShowPageLayout>
  );
};

export default KpiValuesListPage;
